var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ds-tooltip-wrapper', { 'ds-tooltip-wrapper-white': _vm.white }]},[_c('Popper',{attrs:{"options":{
      placement: _vm.placement,
      modifiers: { offset: _vm.offset }
    }}},[_c('div',{staticClass:"popper",style:({ width: _vm.poperWidth })},[_vm._t("popover")],2),_c('div',{staticClass:"reference",attrs:{"slot":"reference"},slot:"reference"},[_vm._t("reference")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }